import React from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from '@dr.pogodin/react-helmet';
import {
  BrowserRouter as Router, Routes, Route,
} from 'react-router';

// Featured
import About from './views/About';
import Looseleafs from './views/Looseleafs';
import Looseleaf from './views/Looseleaf';
import Contact from './views/Contact';
import Index from './views/Index';
import NotFound from './views/NotFound';
import Projects from './views/Projects';
import Resume from './views/Resume';
import Stats from './views/Stats';

// All of our CSS
import './static/css/main.scss';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <HelmetProvider>
    <Router basename={BASE_PATH}>
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/about" element={<About />} />
        <Route path="/looseleafs" element={<Looseleafs />} />
        <Route path="/looseleafs/:slug" element={<Looseleaf />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/stats" element={<Stats />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/resume" element={<Resume />} />
        {/* Only useful in development mode */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  </HelmetProvider>,
);
